module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("教学管理")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n                 教学管理查询\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("教学管理界面显示当前教师所创建的所有课程，课程教学方式分为“自主学习”和“直播授课”，上架状态分为“已上架”和“未上架”，课程状态分为“未开始”、“进行中”、“已结束”，其中自主学习的课程无课程时间以及课程状态。可通过上架状态（未上架、已上架）、课程状态（所有、未开始、进行中、已结束）以及课程名称模糊查询已存在的课程，默认一页显示30条。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/93.png")
    }
  })])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "新建教学课程"
    }
  }, [_c('P', {
    staticClass: "text"
  }, [_vm._v("教师可在此新建教学课程。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(" 步骤一：用户点击【新建课程】，在新建课程界面，完善基本信息的输入。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(" 步骤二：选择教学方式，默认为直播授课。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(" 步骤三：【是否公开】默认公开，开放范围不显示；【是否公开】选择为【私人】时，需选择开放范围。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(" 步骤四：添加影像、病历、附件。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("点击【保存】按钮，新建课程成功，或者点击【直接上架】按钮，新建课程成功并直接上架。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/94.png")
    }
  })])], 1), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "教学课程上架下架"
    }
  }, [_c('P', {
    staticClass: "text"
  }, [_c('b', [_vm._v("上架：")]), _vm._v("选中一条或者多条【未上架】的课程，点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/95.png")
    }
  })]), _vm._v("按钮，课程上架成功，上架状态由【未上架】变为【已上架】。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("【已上架】的课程可在教学中心被查看到。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("下架：选中一条或者多条【已上架】的课程，点击"), _c('b', [_c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/96.png")
    }
  })]), _vm._v("按钮，课程下架成功，上架状态由【已上架】变为【未上架】。上架状态为【已上架】、课程状态为【进行中】的课程不允许下架。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("【未上架】的课程不可在教学中心被查看到。")])], 1), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "教学课程查看"
    }
  }, [_c('P', {
    staticClass: "text"
  }, [_vm._v("在操作列表处点击"), _c('b', [_c('img', {
    staticClass: "ltImg",
    attrs: {
      "src": require("../../../../static/image/78.png")
    }
  })]), _vm._v("，进入查看课程界面。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/97.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("区域1:包含此课程的基本信息以及观看量、评价量、点赞量以及收藏量。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("区域2：包含相关影像、病例、附件以及学员对此课件的评价，可通过tab页切换。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("直播授课：")]), _vm._v("中只有上架状态为【已上架】、课程状态为【进行中】的课程才可进入课程，否则“进入课程”按钮置灰；")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("自主学习：")]), _vm._v("课程上架状态为【已上架】即可进入课程。")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e7a04e2a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/ManageTeach/ManageTeach.vue
// module id = 605
// module chunks = 1 2 3 4 5 6 7 8